// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Bugsnag from 'bugsnag-js'
// Bugsnag.apiKey = 'a7dc866e4a6a2a44f3a9fce3412429a8'
import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import VeeValidate from 'vee-validate'

import 'bootstrap/dist/js/bootstrap'

import 'admin-lte/dist/js/adminlte'

import 'font-awesome/fonts/fontawesome-webfont.eot'
import 'font-awesome/fonts/fontawesome-webfont.svg'
import 'font-awesome/fonts/fontawesome-webfont.ttf'
import 'font-awesome/fonts/fontawesome-webfont.woff'
import 'font-awesome/fonts/fontawesome-webfont.woff2'

import './filters'

import '../node_modules/bootstrap/dist/css/bootstrap.css'

import '../node_modules/admin-lte/dist/css/AdminLTE.css'
import '../node_modules/admin-lte/dist/css/skins/skin-blue.css'

import '../node_modules/font-awesome/css/font-awesome.css'

import '../node_modules/toastr/build/toastr.css'

import './scss/app.scss'

import {ServerTable} from 'vue-tables-2'
import vuetablesConf from '../config/vuetables'

import VueScrollTo from 'vue-scrollto'

import * as VueGoogleMaps from 'vue2-google-maps'
import AccessControl from './helpers/AccessControl'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Vue.use(VeeValidate)

Vue.use(ServerTable, vuetablesConf, true)

Vue.config.productionTip = false

Vue.use(VueScrollTo)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAnDTefg8pqKnl6_k4LI4KlTr3lW4IixwE',
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // // If you want to set the version, you can do so:
    // v: '3.26',
  }

  // // If you intend to programmatically custom event listener code
  // // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // // you might need to turn this on.
  // autobindAllEvents: false,

  // // If you want to manually install components, e.g.
  // // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // // Vue.component('GmapMarker', GmapMarker)
  // // then disable the following:
  // installComponents: true,

})

Vue.prototype.$accessControl = AccessControl

if (process.env.NODE_ENV !== 'production') {
  Bugsnag.start({
    apiKey: process.env.BUGSNAG_KEY,
    plugins: [new BugsnagPluginVue()]
  })
  const bugsnagVue = Bugsnag.getPlugin('vue')
  bugsnagVue.installVueErrorHandler(Vue)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js